module.exports = "<div class=\"lpview_filter_container filter_full_table_listview\"></div>";